import { BASE_URL } from '@app/settings/base-url';
import { baseApi } from '@app/store/index.api';

import {
  IGoogleCallbackQuery,
  IGoogleLoginQuery,
  IGoogleLoginResponse,
  ILoginQuery,
  ILoginResponse,
} from '../model/types';

const authApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    loginAdmin: builder.mutation<ILoginResponse, ILoginQuery>({
      query: credentials => ({
        url: `${BASE_URL}/auth/backoffice`,
        method: 'POST',
        body: {
          ...credentials,
        },
      }),
    }),
    loginMerchant: builder.mutation<ILoginResponse, ILoginQuery>({
      query: credentials => ({
        url: `${BASE_URL}/auth/merchant`,
        method: 'POST',
        body: {
          ...credentials,
          as: 'merchant',
        },
      }),
    }),
    loginProvider: builder.mutation<ILoginResponse, ILoginQuery>({
      query: credentials => ({
        url: `${BASE_URL}/auth/backoffice`,
        method: 'POST',
        body: {
          ...credentials,
          as: 'operator',
        },
      }),
    }),
    loginWithGoogle: builder.mutation<IGoogleLoginResponse, IGoogleLoginQuery>({
      query: params => ({
        url: `${BASE_URL}/auth/redirect`,
        method: 'GET',
        params,
      }),
    }),
    googleCallback: builder.mutation<ILoginResponse, IGoogleCallbackQuery>({
      query: params => ({
        url: `${BASE_URL}/auth/callback`,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useLoginAdminMutation,
  useLoginMerchantMutation,
  useLoginProviderMutation,
  useLoginWithGoogleMutation,
  useGoogleCallbackMutation,
} = authApi;
